import { getError } from "@/utils/get-error";
import { axiosInstance } from "@dexteel/mesf-core";
import { Axios } from "axios";

export class TundishHMRepository {
	private axios: Axios;
	constructor() {
		this.axios = axiosInstance;
		this.getTundishes = this.getTundishes.bind(this);
		this.updateTundishHeatMetrics = this.updateTundishHeatMetrics.bind(this);
	}

	async getTundishes() {
		try {
			const tundishes = await this.axios.get("/Tundish/all");

			return {
				ok: true,
				tundishes: tundishes.data,
			};
		} catch (error: any) {
			const message = getError(error);
			return Promise.reject(message);
		}
	}
	async updateTundishHeatMetrics(tundishId: number | string, dateTime: string) {
		try {
			const date = dateTime === "" ? null : dateTime;
			const tundish = tundishId === "all" ? null : tundishId;
			const resp = await this.axios.patch(`/HeatMetric/tundish-metrics`, {
				tundish,
				date,
			});
			return {
				ok: true,
				resp,
			};
		} catch (error: any) {
			const message = getError(error);

			return Promise.reject(message);
		}
	}
}

export const { getTundishes, updateTundishHeatMetrics } =
	new TundishHMRepository();
